import { Component, OnInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';

@Component({
  selector: 'app-landingpage-footer',
  templateUrl: './landingpage-footer.component.html',
  styleUrls: ['./landingpage-footer.component.css']
})
export class LandingpageFooterComponent implements OnInit {
  public imgLogo: String = 'assets/img/tinnituscare.png';

  constructor(private naviService: NaviService) { }

  ngOnInit() {
  }

  public navigateToImprint() {
    this.naviService.navigateToUrl('/imprint', 'imprint');
  }

  public navigateToDisclaimer() {
    this.naviService.navigateToUrl('/disclaimer', 'disclaimer');
  }

  public navigateToLandingpage() {
    this.naviService.navigateToUrl('/', '');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/landingpage-footer/landingpage-footer.component.ts